const giftCardsNameOverride = {
  'Virtual Promotional Prepaid Mastercard USD': 'Virtual Prepaid MasterCard',
  'Virtual Promotional Prepaid Visa USD': 'Virtual Prepaid Visa',
};

export default giftCardsNameOverride;
